import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import PublicLayout from '../../layout/public/Public';
import './sessions.scss';

const ThankYou = () => {
  return (
    <PublicLayout bgImg={`${window.origin}/content/register-login-bg.png`}>
      <Result
        status='success'
        title='Registration successful. Your profile is under review. Check your email for updates.'
      />
      <Link to='/log-in'>
        <Button
          type='primary'
          style={{
            width: '100%',
            marginTop: '2rem'
          }}
        >
          Login
        </Button>
      </Link>
    </PublicLayout>
  );
};

export default ThankYou;
